import HighlightsCheckBox from './highlights-checkbox';

export default HighlightsCheckBox;
